















import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import LiveChatUserAvatar from "../../../../components/LiveChatUserAvatar";

export default defineComponent({
  name: "StreamMessage",
  components: { LiveChatUserAvatar },
  props: {
    message: { type: Object as () => Message, required: true },
    referrersMap: { type: Object as () => Record<string, UserPublicData>, default: () => ({}) },
  },
});
